import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Alert, Box, Button, ButtonDropdown, FormField, Link, List, Modal, Select, SpaceBetween, Spinner, Table, TextFilter } from '@cloudscape-design/components';

import Header from "@cloudscape-design/components/header";
import { mdiAlertOutline, mdiMagnify, mdiUnfoldMoreVertical } from '@mdi/js';
import Icon from '@mdi/react';
import { intervalToDuration, parse } from 'date-fns';
import DPModal from '../../../../../components/DPModal';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import Favorites from '../../../../../components/extras/Favorites';
import SelectUser from '../../../../../components/selects/selectUser';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, OptionDefinition } from '../../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, minutesToHHMM2, setData, setLoading, setParameters } from '../../../../commons/functions';

export const EDVInstructionStudentsPage = () => {
    const { menu, parameters } = useGlobalState();
    const [students, setStudents] = useState<any[]>([])
    const [student, setStudent] = useState<any>(null)
    const [years, setYears] = useState<OptionDefinition[]>([]);
    const [DGAC, setDGAC] = useState<any[]>([]);
    const [START, setSTART] = useState<any[]>([]);
    const [status, setStatus] = useState<string>("PENDING");
    const [keywords, setKeywords] = useState<string>("");
    const [loadingQueryFlights, setLoadingQueryFlights] = useState(false);


    const licenceTypes = [{ label: "Planeador", value: "GLIDER" }, { label: "Avión", value: "PLANE" }]
    const { navigate } = useRouter();

    const handleGetPeriods = async () => {
        try {
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/edv/students/years',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({})
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.years) {
                setYears(data.years)
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleGetStudents = async () => {
        try {
            setLoading(true);
            console.log(parameters)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/edv/students/list',
                    'JWT': getCookie("JWT"),

                },


                body: JSON.stringify({
                    ...status === "COMPLETE" && { year: parameters.year },
                    columns: "(select (ISNULL(FORMAT(MIN(departureDate), 'dd-MM-yyyy'), '')) from V_Flights_Equipment where idUserPilot=V_Users_Instruction.idUser and groupTypeMasterCode='GLIDER' and idFlightType=1135) as firstFlight ,*",
                    licenceType: parameters.course,
                    complete: status === "COMPLETE" ? 1 : status === "PENDING" ? 0 : -1,
                    orderBy: "idUserStudent",
                    order: "ASC"
                })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.students) {
                setStudents(data.students)
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleGetStudentCourses = async () => {

        if (student && student.idUserStudent === 0) {
            try {
                setLoading(true);
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/edv/students/list',
                        'JWT': getCookie("JWT"),

                    },

                    body: JSON.stringify({
                        licenceType: student.licenceType,
                        idUser: student.idUser,
                    })
                });
                if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

                const data = await response.json();
                if (data && data.students) {
                    setStudent({ ...student, courses: data.students })
                }
            } catch (error) {
                console.error('Error fetching users:', error);
            } finally {
                setLoading(false);
            }
        }
    };
    const handleGetExams = async () => {
        try {
            setLoadingQueryFlights(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/flights/list',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({
                    columns: "departureDate, idFlight, registration, departureDate, arrivalDate, departureArrivalDelta, flightType",
                    idFlightType: 2799,
                    idUserPilot: student.idUser,
                    groupTypeMasterCode: student.licenceType
                })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();

            if (data && data.flights) {
                setDGAC(data.flights.map((f: any) => ({

                    text: f.registration,
                    id: f.departureDate + "." + f.idFlight,
                    secondaryText: f.departureDate,
                    labelTag: minutesToHHMM2(f.departureArrivalDelta)
                })))
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoadingQueryFlights(false);
        }
    };


    const handleFirstFlight = async () => {
        try {
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/flights/list',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    columns: "departureDate, idFlight, registration, departureDate, arrivalDate, departureArrivalDelta, flightType",
                    idFlightType: 1135,
                    idUserPilot: student.idUser,
                    groupTypeMasterCode: student.licenceType,
                    orderBy: "arrivalDate",
                    order: "ASC",
                    limit: 1
                })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.flights) {
                setSTART(data.flights.map((f: any) => ({
                    text: f.registration,
                    id: f.departureDate + "." + f.idFlight,
                    secondaryText: f.departureDate,
                    labelTag: minutesToHHMM2(f.departureArrivalDelta)
                })))
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleUpdateStudent = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/edv/students/update',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify(student)
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data.code === 0) {
                addNotification(data.status, "success", setData)
                handleGetStudents();
                setStudent(null);
            } else {
                addNotification(data.status, "error", setData)
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const filtered = students.filter((s) => {
        const searchTerms = keywords.toLowerCase().trim().replace("  ", " ").split(' ').filter(word => word !== '');
        const searchableFields = [
            s.displayName,
            s.instructor,
            s.licenceType,
            s.dateStart,
            s.dateLicence
        ].join(' ').toLowerCase();

        return searchTerms.every(term => searchableFields.includes(term));
    });

    useEffect(() => {
        //handleGetStudents();
    }, [parameters.year]);

    useEffect(() => {
        if (student && student.licenceType && student.licenceType !== "" && student.idUser && student.idUser > 0) {
            handleGetExams();
            handleFirstFlight();
            handleGetStudentCourses()
        }
    }, [student?.idUser, student?.licenceType]);
    useEffect(() => {
        handleGetPeriods();
    }, []);


    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}
                        description="Asociador de alumnos con intructores y cursos. Se permite ingresar el inicio del curso (Primer vuelo del tipo con el instructor) y la fecha de licencia (Vuelo del tipo Examen DGAC) para el curso.">
                        <SpaceBetween direction='horizontal' size='xs'><span>Alumnos</span><Icon path={mdiUnfoldMoreVertical} size={1} />
                            <span>Instructores</span></SpaceBetween></Header>

                    <Header variant="h2" actions={<FormField label="&nbsp;"><Button variant="primary" onClick={() => {
                        setSTART([]);
                        setDGAC([]);
                        setStudent({ idUserStudent: 0, idUser: 0, idInstructor: 0, dateStart: "", licenceType: "" })

                    }}
                    >Agregar alumno</Button></FormField>}>
                        <SpaceBetween direction="horizontal" size="xs">

                            <FormField label="Estado">
                                <Select
                                    options={[{ label: "Pendiente", value: "PENDING" }, { label: "Finalizado", value: "COMPLETE" }, { label: "Sin asignación", value: "UNASSIGNED" }]}
                                    selectedOption={[{ label: "Pendiente", value: "PENDING" }, { label: "Finalizado", value: "COMPLETE" }, { label: "Sin asignación", value: "UNASSIGNED" }].find(c => c.value === status) || { label: "Pendiente", value: "PENDING" }}
                                    onChange={({ detail }) => {
                                        setStatus(detail.selectedOption.value);
                                    }}
                                />
                            </FormField>
                            {status === "COMPLETE" && (
                                <FormField label="Filtro anual">
                                    <Select
                                        options={years}
                                        selectedOption={years.find(y => y.value.toString() === parameters.year.toString()) || null}
                                        onChange={({ detail }) => {
                                            if (detail && detail.selectedOption.value !== "") {
                                                setParameters({
                                                    ...parameters,
                                                    year: Number(detail.selectedOption.value)
                                                });
                                            }
                                        }}
                                    />
                                </FormField>
                            )}
                            <FormField label="Tipo de curso">
                                <Select
                                    options={[{ label: "Planeador", value: "GLIDER" }, { label: "Avión", value: "PLANE" }]}
                                    selectedOption={[{ label: "Planeador", value: "GLIDER" }, { label: "Avión", value: "PLANE" }].find(c => c.value === parameters.course) || { label: "Planeador", value: "GLIDER" }}
                                    onChange={({ detail }) => {
                                        setParameters({
                                            ...parameters,
                                            course: detail.selectedOption.value
                                        });
                                    }}
                                />
                            </FormField>
                            <FormField label="&nbsp;">
                                <Button style={{ root: btnIconForm }}
                                    disabled={parameters.year === "" || parameters.course === ""}
                                    onClick={() => handleGetStudents()}><Icon path={mdiMagnify} size={1} /></Button>
                            </FormField>
                        </SpaceBetween>

                    </Header>
                    <Table
                        stickyHeader
                        variant='embedded'
                        header={
                            <TextFilter disabled={students.length === 0} filteringPlaceholder="Filtrar alumno/instructor..." filteringText={keywords} onChange={({ detail }) => {
                                setKeywords(detail.filteringText);
                            }} />
                        }

                        columnDefinitions={[
                            {
                                id: 'instructor', header: 'Alumno/Instructor', cell: item => <FormField label={<Link onClick={() => {

                                    setSTART([]);
                                    setDGAC([]);
                                    setStudent(item);
                                }}>
                                    {item.displayName}</Link>}>{item?.instructor}</FormField>
                            },
                            { id: 'course', header: 'Curso', cell: item => item?.licenceType === "GLIDER" ? "Planeador" : item?.licenceType === "PLANE" ? "Avión" : "Desconocido" },
                            { id: 'status', header: 'Estado', cell: item => item.idInstructor === 0 ? <BadgeCustom color="red">No asignado</BadgeCustom> : item.dateStart === "" ? <BadgeCustom color="orange">No iniciado {item.firstFlight !== "" ? <Icon path={mdiAlertOutline} size={0.75} /> : null}</BadgeCustom> : item.dateStart !== "" && item.dateLicence === "" ? <BadgeCustom color="blue">En curso</BadgeCustom> : item.dateStart !== "" && item.dateLicence !== "" ? "Finalizado" : "Desconocido" },
                        ]}
                        items={filtered}
                        loadingText="Cargando alumnos..."
                    />
                    <Modal size="small" onDismiss={() => setStudent(null)} visible={student !== null} closeAriaLabel="Cerrar modal de alumno"
                        header={<Header variant="h2" description={`${student?.displayName ?? ""}`}>{student?.idUserStudent && student.idUserStudent > 0 ? `Editar alumno ` : "Agregar nuevo alumno"}</Header>}
                        footer={

                            <Box>
                                <Box float="left">
                                    <Button variant="link" onClick={() => setStudent(null)}>Cancelar</Button></Box>
                                <Box float="right">
                                    <Button variant="primary" onClick={() => handleUpdateStudent()}
                                        disabled={!student || student.idUser === 0
                                            || !student.licenceType || student.licenceType === ""
                                            //|| !student.dateStart || student.dateStart === ""
                                            || !student.idUser || student.idUser === 0
                                            //|| !student.idInstructor || student.idInstructor === 0
                                            || (student && student.courses && student.courses.length > 0 && student.idUserStudent === 0)
                                        }
                                    >{student && student.idUserStudent === 0 ? "Ingresar" : "Actualizar"}</Button></Box>

                            </Box>
                        }
                    >
                        <SpaceBetween size="s" direction='vertical'>
                            {student && student.courses && student.courses.length > 0 && (
                                <Alert type="warning" header="Atención">
                                    Este alumno ya esta inscrito en uno o más cursos. No se puede duplicar el curso
                                    <List
                                        items={student.courses.map((c: any) => ({
                                            id: c.idUserStudent,
                                            content: `${c.licenceType === "GLIDER" ? "Planeador" : c.licenceType === "PLANE" ? "Avión" : "Desconocido"} - ${c.instructor}`,
                                            description: `Inicio: ${c.dateStart} - Termino: ${c.dateLicence === "" ? "Pendiente" : c.dateLicence}`
                                        }))}
                                        renderItem={({ id, content, description }) => ({
                                            id,
                                            content: content,
                                            secondaryContent: (
                                                <Box variant="small">{description}</Box>
                                            )
                                        })}
                                    />

                                </Alert>
                            )}
                            <FormField label="Tipo de curso">
                                <Select options={licenceTypes}
                                    selectedOption={licenceTypes.find(c => c.value === student?.licenceType) || null}
                                    onChange={({ detail }) => {
                                        if (!student) return;
                                        setStudent({ ...student, licenceType: detail.selectedOption.value })

                                    }}
                                />
                            </FormField>
                            {student && student.licenceType && student.licenceType !== "" && (
                                <>
                                    <FormField label="Alumno">
                                        <SelectUser
                                            readonly={student && student.idUserStudent && student.idUserStudent > 0}
                                            onConfirm={(user) => {
                                                if (user)
                                                    setStudent({ ...student, idUser: user.idUser })
                                                else
                                                    setStudent({ ...student, idUser: 0 })
                                            }}
                                            value={student ? student.idUser || 0 : 0}
                                        />
                                    </FormField>
                                    <FormField label="Instructor">
                                        <SelectUser
                                            filter={`INSTRUCTOR.${student.licenceType}`}
                                            onConfirm={(user) => {
                                                if (user)
                                                    setStudent({ ...student, idInstructor: user.idUser })
                                                else
                                                    setStudent({ ...student, idInstructor: 0 })
                                            }}
                                            value={student ? student.idInstructor || 0 : 0}
                                        />
                                    </FormField>
                                    {student && student.idInstructor > 0 && (
                                        <>
                                            <FormField label={<>Fecha inicio {loadingQueryFlights ? <Spinner size="normal" /> : null}</>}

                                                info={
                                                    START && START.length > 0 && (<Link
                                                        onClick={() => {
                                                            setStudent({ ...student, dateStart: START[0]?.secondaryText })

                                                        }}
                                                    >{START[0]?.secondaryText}-{START[0].text}</Link>)
                                                }>
                                                <DPModal
                                                    date={student ? student.dateStart || "" : ""} onConfirm={(date) => {
                                                        if (!student) return;
                                                        setStudent({ ...student, dateStart: date })
                                                    }} />

                                            </FormField>
                                            <FormField label={
                                                <SpaceBetween direction='horizontal' size='xs'>
                                                    <span>Fecha de licencia</span>
                                                    {loadingQueryFlights ? <Spinner size="normal" /> : null}
                                                    {DGAC && DGAC.length > 0 && (
                                                        <ButtonDropdown
                                                            items={DGAC}
                                                            ariaLabel="Control instance"
                                                            variant="inline-icon"
                                                            onItemClick={(e) => {
                                                                setStudent({ ...student, dateLicence: e.detail.id.split(".")[0] })
                                                            }}
                                                        />)}
                                                </SpaceBetween>
                                            }>
                                                <DPModal date={student ? student.dateLicence || "" : ""} onConfirm={(date) => {
                                                    console.log(date)
                                                    if (!student) return;
                                                    setStudent({ ...student, dateLicence: date })
                                                }} />

                                            </FormField>
                                        </>)}
                                </>
                            )}
                        </SpaceBetween>
                    </Modal >
                </SpaceBetween >
            }
        />
    )
};

function interval2Duration(start: string, end: string) {
    if (start === "" || end === "") return "";
    const startDate = parse(start, "dd-MM-yyyy", new Date());
    const endDate = parse(end, "dd-MM-yyyy", new Date());
    if (!startDate || !endDate) return "";

    const duration = intervalToDuration({ start: startDate, end: endDate });
    if (!duration) return "";
    let formattedDuration = '';
    if (duration.years && duration.years > 0) {
        formattedDuration += `${duration.years}A `;
    }
    if (duration.months && duration.months > 0) {
        formattedDuration += `${duration.months}M `;
    }
    if (duration.days && duration.days > 0) {
        formattedDuration += `${duration.days}D `;
    }
    // Add other units as needed (hours, minutes, etc.)

    return (formattedDuration.trim());
}